import { createTemplateTag } from '../Tag';
import { extractValueWithPath } from '../ResolveValue';
export var props = createTemplateTag('props', function (path, context) {
  return extractValueWithPath(context.props, path);
});
export var string = createTemplateTag('string', function (path) {
  return path;
});